import { MetricConverter } from './helpers';

const FrequencyUnits = ['Hz', 'kHz', 'MHz', 'GHz', 'mHz'] as const;
type TFrequencyUnit = (typeof FrequencyUnits)[number];

class FrequencyConverter extends MetricConverter<TFrequencyUnit, 'Hz'> {
    baseUnit = 'Hz' as const;
    units = FrequencyUnits;
}

export const frequencyConverter = new FrequencyConverter();
